<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="typing-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-volume-up"></i>
                        打鍵音
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>打鍵音</label>
                        <div class="btn-group btn-block">
                            <button type="button" class="btn btn-outline-secondary" :class="{active: user.typing_sound == 0}" @click="user.typing_sound = 0">無し</button>
                            <button type="button" class="btn btn-outline-secondary" :class="{active: user.typing_sound == 1}" @click="user.typing_sound = 1">ｶｶｶｶ...</button>
                            <button type="button" class="btn btn-outline-secondary" :class="{active: user.typing_sound == 2}" @click="user.typing_sound = 2">ﾄﾞﾙﾙﾙ...</button>
                            <button type="button" class="btn btn-outline-secondary" :class="{active: user.typing_sound == 3}" @click="user.typing_sound = 3">ﾄﾄﾄﾄ...</button>
                            <button type="button" class="btn btn-outline-secondary" :class="{active: user.typing_sound == 4}" @click="user.typing_sound = 4">赤</button>
                            <button type="button" class="btn btn-outline-secondary" :class="{active: user.typing_sound == 5}" @click="user.typing_sound = 5">茶</button>
                            <button type="button" class="btn btn-outline-secondary" :class="{active: user.typing_sound == 6}" @click="user.typing_sound = 6">青</button>
                        </div>
                        <div class="text-muted small">
                            打鍵時の音を指定できます。
                            本棚ページの文字打ちカーソル音と同じ音源です。
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="save()">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: {},
        }
    },
    methods: {
        load() {
            axios.get("/mypage/user/get").then(res => {
                this.user = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        save() {
            axios.post("/mypage/user/save", this.user).then(res => {
                alert.msg("保存しました。");
                this.$store.commit("login", this.user);
                $("#typing-modal").modal("hide");
                this.$emit("saved");
            }).catch(err => { alert.err(err.response) });
        },
    },
    mounted() {
        $("#typing-modal").on("show.bs.modal", (e) => {
            this.load();
        });
    },
}
</script>